<router-outlet></router-outlet>
<ngx-spinner name="fullscreen" #fullscreen class="mv-spinner" [fullScreen]="true" type="x" [template]="spinnerTemplate" size="medium"></ngx-spinner>